import { StateCreator } from 'zustand'

import { Module, Operation } from '@/types/auth'

export interface PermissionState {
    modules: Module[]
    activeModule: Module | null
    activeView: {
        viewId: number
        operations: Operation[]
    } | null
}

export interface PermissionActions {
    setModules: (modules: Module[]) => void
    setActiveModule: (moduleId: number) => void
    setActiveView: (viewId: number, operations: Operation[]) => void
}

export type PermissionSlice = PermissionState & PermissionActions

export const createPermissionSlice: StateCreator<PermissionSlice> = (
    set,
    get
) => ({
    modules: [],
    activeModule: null,
    activeView: null,
    setModules: (modules) => set({ modules }),
    setActiveModule: (moduleId) =>
        set((state) => ({
            activeModule:
                state.modules.find((m) => m.moduleId === moduleId) || null
        })),
    setActiveView: (viewId, operations) =>
        set({
            activeView: { viewId, operations }
        })
})
